export default "__VITE_ASSET__BGgmgBdS__"